module.exports = __webpack_public_path__ + "img/purple-graph.6d92c33d.svg";